import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ApiCallService } from '../../Services/api-call-service.service';
import { ToastrService } from 'ngx-toastr';
import { ErrorhandlingService } from '../../Services/error-handling.service';
import { LoaderService } from '../../Services/loader-service.service';

@Component({
  selector: 'app-view-referal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './view-referal.component.html',
  styleUrl: './view-referal.component.scss'
})
export class ViewReferalComponent implements OnInit {
  referrals: any[] = [];
  
  // Empty State Flags
  isReferralsLoaded = false;
  isTransactionsLoaded = false;

  // Modal State
  isTransactionModalOpen = false;
  selectedUser: any = null;
  transactionDetails: any[] = [];

  constructor(
    private router: Router,
    private apiCallService: ApiCallService,
    private toaster: ToastrService,
    private handleError: ErrorhandlingService,
    public loaderService: LoaderService,
  ) {}

  ngOnInit(): void {
    this.getReferrals();
  }

  getReferrals() {
    this.loaderService.show();
    this.isReferralsLoaded = false;
    const userId = localStorage.getItem('customerId');
    
    this.apiCallService
      .GetCallWithoutToken(`User/GetRefferralRecords?userid=${userId}`)
      .subscribe({
        next: (response: any) => {
          this.isReferralsLoaded = true;
          this.loaderService.hide();
          if (response?.responseCode === 200) {
            this.referrals = response.data || [];
          } else {
            this.handleError.handleResponseError(response);
          }
        },
        error: (error) => {
          this.isReferralsLoaded = true;
          this.loaderService.hide();
          this.handleError.handleHttpError(error);
        }
      });
  }

  viewTransactions(user: any) {
    this.selectedUser = user;
    this.isTransactionModalOpen = true;
    this.fetchTransactionDetails(user.ReferelCustomerId); 
  }

  fetchTransactionDetails(customerId: string) {
    this.loaderService.show();
    this.isTransactionsLoaded = false;
    
    this.apiCallService.GetCallWithoutToken(`User/GetRefferedcustomerPayments?CustomerId=${customerId}`)
      .subscribe({
        next: (res: any) => {
          this.isTransactionsLoaded = true;
          this.loaderService.hide();
          if (res?.responseCode === 200) {
            this.transactionDetails = res.data || [];
          } else {
            this.handleError.handleResponseError(res);
          }
        },
        error: (err) => {
          this.isTransactionsLoaded = true;
          this.loaderService.hide();
          this.handleError.handleHttpError(err);
        }
      });
  }

  getTransactionsTotal(): string {
    const total = (this.transactionDetails || []).reduce(
      (sum, tx) => sum + (Number(tx?.Balance) || 0),
      0
    );
    return total.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }

  closeTransactionModal() {
    this.isTransactionModalOpen = false;
    this.selectedUser = null;
    this.transactionDetails = [];
  }

  goBack() {
    this.router.navigate(['dashboard/home']); 
  }
}